import React from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import { connect } from 'react-redux'
import i18n from '~/i18n'

@connect((store) => {
    return { siteMaster: store.siteMaster, user: store.user }
})
export default class QuickTips extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        return (
            <Paper className='m-mar-b0'>
                <div>
                    <h4 className='mar-b5'>{i18n.t('dashboard:useful-links.title')}</h4>
                    <div className='mar-b15'>{i18n.t('dashboard:useful-links.subtitle')}</div>

                    <div className='simpleList mar-b30'>
                        <QuickLink
                            icon='arrowRight'
                            label={i18n.t('dashboard:useful-links.add-group')}
                            href='https://transpond.io/support/managing-your-audience/organizing-your-contacts-with-groups'
                        />
                        <QuickLink
                            icon='arrowRight'
                            label={i18n.t('dashboard:useful-links.send-campaign')}
                            href='https://transpond.io/support/creating-and-sending-campaigns/understanding-email-campaigns'
                        />
                        <QuickLink
                            icon='arrowRight'
                            label={i18n.t('dashboard:useful-links.add-custom-field')}
                            href='https://transpond.io/support/managing-your-audience/working-with-custom-fields'
                        />
                    </div>
                </div>
                {!!this.props.siteMaster.supportUrl && (
                    <div>
                        <Paper
                            className='paper-primary paper-tight quickFlex mar-b0'
                            style={{ justifyContent: 'space-between', padding: '24px' }}
                        >
                            <div className='mar-r20' style={{ fontSize: '16px', fontWeight: 600, lineHeight: '22px' }}>
                                {i18n.t('dashboard:useful-links.support-heading')}
                            </div>
                            <div>
                                <Button
                                    href={this.props.siteMaster.supportUrl}
                                    target='_blank'
                                    style={{ whiteSpace: 'nowrap' }}
                                    className='button-primary button-lighten'
                                    iconLeft={<Icons icon='lifering' style={{ width: '20px', height: '20px' }} />}
                                >
                                    {i18n.t('dashboard:useful-links.support-cta')}
                                </Button>
                            </div>
                        </Paper>
                    </div>
                )}
            </Paper>
        )
    }
}

const QuickLink = ({ icon, label, href }) => (
    <a className='simpleList-item simpleList-item-dividingLine' href={href} target='_blank'>
        <span>{label}</span>
        <Icons icon={icon} />
    </a>
)
